import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export const ScrollMenu = ({data, active}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Features</div>

      {data.map((item, index) => (
        <ScrollMenuItem key={index} text={item.text} onClick={item.onClick} active={active} />
      ))}
    </div>
  );
};

const ScrollMenuItem = ({text, onClick, active}) => {
  return (
    <div className={styles.item} onClick={onClick}>
      <div
        className={clsx(styles.line, {
          [styles.active]: text === active,
        })}></div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};
